import { toast } from "react-toastify";
import {
    deleteDataFromApi,
    getDataFromApi,
    postDataFromApi,
    putDataFromApi,
} from "../../../../../services/commonServices";
import { DepartmentMasterUpdateApi, DepartmentMasterDeleteApi, DepartmentMasterCreateApi, DepartmentMasterGetApi } from "../../../../../services/api";

export const handleGetDepartment = async (EditRecordId, setFormData, status, setIsOverlayLoaders) => {

    try {
        setIsOverlayLoaders(true)
        const getDepartmentMaster = DepartmentMasterGetApi(EditRecordId);
        let res = await postDataFromApi(getDepartmentMaster,
            {
                "model_name": "department",
                id: parseInt(EditRecordId)
            }
        )

        if (res.data.status === 200) {
            setFormData((prevFormData) => {
                return {
                    0: {
                        ...prevFormData[0],
                        ...res?.data?.data,


                    },
                };
            });
        }
        else {
            toast.error(res.message, {
                position: "top-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
        }
    } catch (error) {
        // console.log('errrr',error)
    }
    finally {
        setIsOverlayLoaders(false)
    }
}

// export const handleDepartmentCreateUpdate = async (
//     formData,
//     handleSubmit,
//     setIsOverlayLoader,
//     navigate,
//     status,
//     isCustomPopup,
//     setIsCustomPopup,
//     setFormData,
//     section
// ) => {
//     try {
//         setIsOverlayLoader(true)
//         if (!isCustomPopup) {
//             let isValidate = handleSubmit();
//             if (!isValidate) {
//                 return false;
//             }
//         }
//         let payloadData = {
//             dept_name: formData[0]?.dept_name,
//             dept_code: formData[0]?.dept_code,
//             "model_name": "department"
//         };
//         let res
//         if (formData[0].dept_id) {
//              let newPayloadData = {
//            ...payload,
//            id
//         };
//             const departmentUpdateUrl = DepartmentMasterUpdateApi(formData[0].dept_id);
//             res = await putDataFromApi(departmentUpdateUrl, newPayloadData)

//         } else {
//             res = await postDataFromApi(DepartmentMasterCreateApi, payloadData);
//         }
//         if (res?.data?.status === 200) {

//             toast.success(res?.data?.message, {
//                 position: "top-right",
//                 autoClose: 2000,
//                 hideProgressBar: false,
//                 closeOnClick: true,
//                 pauseOnHover: true,
//                 draggable: true,
//                 progress: undefined,
//                 theme: "light",
//             });

//         } else {
//             toast.error(res.message, {
//                 position: "top-right",
//                 autoClose: 2000,
//                 hideProgressBar: false,
//                 closeOnClick: true,
//                 pauseOnHover: true,
//                 draggable: true,
//                 progress: undefined,
//                 theme: "light",
//             });
//         }
//     }
//     catch (ex) {
//         console.log('---', ex)
//     }
//     finally {
//         setIsOverlayLoader(false)
//         navigate("/departmentList")
//     }
// }

export const handleDepartmentCreateUpdate = async (
    formData,
    handleSubmit,
    setIsOverlayLoader,
    navigate,
    status,
    isCustomPopup,
    setIsCustomPopup,
    setFormData,
    section
) => {
    try {
        setIsOverlayLoader(true);

        if (!isCustomPopup) {
            let isValidate = handleSubmit();
            if (!isValidate) return false;
        }

        // common data object
        const departmentData = {
            dept_name: formData[0]?.dept_name,
            dept_code: formData[0]?.dept_code,
            is_active: status ?? true
        };

        let res;

        if (formData[0]?.dept_id) {
            // UPDATE payload
            const updatePayload = {
                id: formData[0].dept_id,
                data: departmentData
            };

            const departmentUpdateUrl = DepartmentMasterUpdateApi(formData[0].dept_id);
            res = await putDataFromApi(departmentUpdateUrl, updatePayload);
        } else {
            const createPayload = {
                data: departmentData
            };

            res = await postDataFromApi(DepartmentMasterCreateApi, createPayload);
        }

        if (res?.data?.status === 200) {
            toast.success(res?.data?.message, {
                position: "top-right",
                autoClose: 2000,
                theme: "light",
            });
        } else {
            toast.error(res?.message, {
                position: "top-right",
                autoClose: 2000,
                theme: "light",
            });
        }
    } catch (ex) {
        console.error(ex);
    } finally {
        setIsOverlayLoader(false);
        navigate("/departmentList");
    }
};


export const handleDepartmentDelete = async (
    row,
    setIsDelete,
    getAllListingData,
    setPopupIndex

) => {
    try {

        let res;
        const updatePayload = {
            id: row?.dept_id,       
            data: {
                dept_name: row?.dept_name,
                dept_code: row?.dept_code,
                is_active: false
            }
        };
        const departmentUpdateUrl = DepartmentMasterUpdateApi(row.dept_id);
        res = await putDataFromApi(departmentUpdateUrl, updatePayload);
        if (res?.data?.status === 200) {
            toast.success(res.data.message, {
                position: "top-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
            getAllListingData();
        } else {
            toast.error(res.message, {
                position: "top-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
        }
    }
    catch (ex) { }
    finally {
        setIsDelete(false);
        setPopupIndex(-1);
    }


}